export default __webpack_public_path__ + "static/media/background.cdbcaa29.png";